"use client";

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
import { formatTokenAmount, safeBigInt } from "../../../../shared/utils/number.js";
import { useMemo } from "react";
import { CartItemRow } from "./CartItemRow.js";
import { CartSummary } from "./CartSummary.js";
import { PoweredByBranding } from "./PoweredByBranding.js";
import { PriceSkeleton } from "./PriceSkeleton.js";
export function CheckoutCartPanel({
  items,
  totalAmount,
  tokenSymbol = "",
  tokenDecimals = 18,
  pricesLoading = false,
  organizationName,
  organizationLogo,
  classes,
  footer,
  shipping,
  tax,
  discount,
  summaryLines,
  usdEquivalent
}) {
  const formattedTotal = useMemo(() => formatTokenAmount(safeBigInt(totalAmount), tokenDecimals), [totalAmount, tokenDecimals]);
  // Compute subtotal from items only (before adjustments)
  const formattedSubtotal = useMemo(() => {
    let subtotal = BigInt(0);
    for (const item of items) {
      subtotal += safeBigInt(item.amount) * BigInt(item.quantity);
    }
    return formatTokenAmount(subtotal, tokenDecimals);
  }, [items, tokenDecimals]);
  return _jsxs("div", {
    className: cn("anyspend-cart-panel flex flex-col", classes?.cartPanel),
    "aria-busy": pricesLoading || undefined,
    children: [_jsx("h2", {
      className: cn("anyspend-cart-title mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100", classes?.cartTitle),
      children: "Order Summary"
    }), _jsx("div", {
      className: "anyspend-cart-items divide-y divide-gray-100 dark:divide-gray-800",
      children: items.map((item_0, index) => {
        const itemTotal = safeBigInt(item_0.amount) * BigInt(item_0.quantity);
        const formattedPrice = pricesLoading ? _jsx(PriceSkeleton, {}) : `${formatTokenAmount(itemTotal, tokenDecimals)} ${tokenSymbol}`;
        return _jsx(CartItemRow, {
          item: item_0,
          formattedPrice: formattedPrice,
          classes: classes
        }, item_0.id || index);
      })
    }), _jsx(CartSummary, {
      total: pricesLoading ? _jsx(PriceSkeleton, {
        className: "w-20"
      }) : formattedTotal,
      tokenSymbol: tokenSymbol,
      classes: classes,
      subtotal: formattedSubtotal,
      tokenDecimals: tokenDecimals,
      shipping: shipping,
      tax: tax,
      discount: discount,
      summaryLines: summaryLines,
      usdEquivalent: usdEquivalent,
      pricesLoading: pricesLoading
    }), footer === undefined ? _jsx(PoweredByBranding, {
      organizationName: organizationName,
      organizationLogo: organizationLogo,
      classes: classes
    }) : footer]
  });
}